export const GET_Hair_Products_Details = "GET_Hair_Products_Details";
export const GET_Hair_Products_Questions = "GET_Hair_Products_Questions"
export const SET_ERROR_PAGE = "SET_ERROR_PAGE";

export const SET_PAYMENT_INTENT = 'SET_PAYMENT_INTENT'
